import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './BrowseRFQ.css';

// Mock RFQ data with business info and files
const MOCK_RFQS = [
  {
    id: 'mock-1',
    title: 'E-commerce Website Development',
    description: 'Need a full-featured e-commerce website built with React and Node.js. Must include payment gateway integration, admin panel, and inventory management. Looking for someone experienced in building scalable web applications with secure payment processing.',
    category: 'web-development',
    industry: 'Retail & E-commerce',
    budget: '50000-100000',
    budgetDisplay: 'R50,000 - R100,000',
    timeline: '2-3-months',
    postedDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    closingDate: new Date(Date.now() + 12 * 24 * 60 * 60 * 1000),
    company: 'ABC Retail',
    companyLogo: 'https://via.placeholder.com/80x80/003d7a/ffffff?text=AR',
    workLocation: 'remote',
    status: 'open',
    proposalsCount: 12,
    skillsRequired: ['React', 'Node.js', 'MongoDB', 'Payment Integration', 'API Development'],
    attachments: [
      { name: 'Project_Brief.pdf', url: '#', size: '2.4 MB' },
      { name: 'Technical_Requirements.docx', url: '#', size: '1.1 MB' }
    ],
    replyRequirements: {
      workScope: 'Provide detailed project timeline, tech stack proposal, and past e-commerce projects',
      portfolio: 'Required - Must show 2+ e-commerce sites built',
      experience: 'Practical experience with online payments - no formal degree required',
      deliverables: ['Fully functional e-commerce website', 'Admin dashboard', 'Payment gateway integration', 'Mobile responsive design', 'Documentation and handover']
    }
  },
  {
    id: 'mock-2',
    title: 'Brand Identity Design Package',
    description: 'Looking for a creative designer to develop complete brand identity including logo, color palette, typography, and brand guidelines for a new fintech startup.',
    category: 'graphic-design',
    industry: 'Finance & Banking',
    budget: '10000-25000',
    budgetDisplay: 'R10,000 - R25,000',
    timeline: '1-2-months',
    postedDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
    closingDate: new Date(Date.now() + 9 * 24 * 60 * 60 * 1000),
    company: 'FinStart Solutions',
    companyLogo: 'https://via.placeholder.com/80x80/003d7a/ffffff?text=FS',
    workLocation: 'hybrid',
    specificLocation: 'Cape Town, SA',
    status: 'open',
    proposalsCount: 8,
    skillsRequired: ['Adobe Illustrator', 'Brand Strategy', 'Typography', 'Photoshop'],
    attachments: [
      { name: 'Brand_Guidelines_Draft.pdf', url: '#', size: '3.2 MB' }
    ],
    replyRequirements: {
      workScope: 'Show brand identity packages you\'ve created with before/after examples',
      portfolio: 'Required - Minimum 3 brand identity projects',
      experience: 'Self-taught designers welcome - show us your creative work',
      deliverables: ['Logo design (multiple concepts)', 'Color palette', 'Typography guide', 'Brand guidelines document', 'Social media templates']
    }
  },
  {
    id: 'mock-3',
    title: 'Monthly Bookkeeping Services',
    description: 'Small business seeking reliable bookkeeper for monthly financial records, reconciliations, and SARS submissions. QuickBooks experience preferred.',
    category: 'bookkeeping',
    industry: 'Energy & Utilities',
    budget: '5000-10000',
    budgetDisplay: 'R5,000 - R10,000/month',
    timeline: 'ongoing',
    postedDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
    closingDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000),
    company: 'Green Energy Co',
    companyLogo: 'https://via.placeholder.com/80x80/003d7a/ffffff?text=GE',
    workLocation: 'remote',
    status: 'open',
    proposalsCount: 5,
    skillsRequired: ['QuickBooks', 'SARS Compliance', 'Financial Reporting', 'Excel'],
    attachments: [],
    replyRequirements: {
      workScope: 'Detail your monthly bookkeeping process and SARS submission experience',
      portfolio: 'Not required - practical experience is what matters',
      experience: 'Hands-on QuickBooks and SARS experience - formal qualification not necessary',
      deliverables: ['Monthly financial statements', 'Bank reconciliations', 'SARS submissions', 'Expense tracking', 'Financial reports']
    }
  },
  {
    id: 'mock-4',
    title: 'Mobile App Development',
    description: 'Develop a delivery app similar to Uber Eats for local restaurants. Need both iOS and Android versions with real-time tracking and payment integration.',
    category: 'software-development',
    industry: 'Food & Hospitality',
    budget: '100000-200000',
    budgetDisplay: 'R100,000 - R200,000',
    timeline: '3-6-months',
    postedDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    closingDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    company: 'FoodHub',
    companyLogo: 'https://via.placeholder.com/80x80/003d7a/ffffff?text=FH',
    workLocation: 'remote',
    status: 'open',
    proposalsCount: 15,
    skillsRequired: ['React Native', 'Flutter', 'Firebase', 'Google Maps API'],
    attachments: [
      { name: 'App_Wireframes.pdf', url: '#', size: '5.8 MB' },
      { name: 'Feature_Specifications.docx', url: '#', size: '2.1 MB' },
      { name: 'User_Flow_Diagrams.pdf', url: '#', size: '1.9 MB' }
    ],
    replyRequirements: {
      workScope: 'Provide technical architecture, development phases, and testing plan',
      portfolio: 'Required - Live app links (App Store/Play Store) or demo videos',
      experience: 'Must have built and deployed mobile apps - bootcamp grads welcome',
      deliverables: ['iOS app', 'Android app', 'Admin panel', 'Real-time tracking', 'Payment integration', 'Push notifications']
    }
  }
];

const BrowseRFQ = (props) => {
  const [rfqs, setRfqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRfq, setExpandedRfq] = useState(null);
  const [savedRfqs, setSavedRfqs] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const useMockData = true;

  useEffect(() => {
    document.title = 'Browse RFQs | Global Expedyte';
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (useMockData) {
      setRfqs(MOCK_RFQS);
      setLoading(false);
      return;
    }
    
    // When ready to use Firebase, uncomment:
    // const rfqsRef = collection(db, 'rfqs');
    // const q = query(rfqsRef, where('status', '==', 'open'), orderBy('postedDate', 'desc'));
    // const unsubscribe = onSnapshot(q, (snapshot) => {
    //   const rfqsData = snapshot.docs.map(doc => ({
    //     id: doc.id,
    //     ...doc.data(),
    //     postedDate: doc.data().postedDate?.toDate() || new Date()
    //   }));
    //   setRfqs(rfqsData);
    //   setLoading(false);
    // });
    // return () => unsubscribe();
  }, [useMockData]);

  const formatDate = (date) => {
    return date.toLocaleDateString('en-ZA', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const getDaysRemaining = (closingDate) => {
    const now = new Date();
    const diffTime = closingDate - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) return 'Closed';
    if (diffDays === 0) return 'Closes today';
    if (diffDays === 1) return '1 day left';
    return `${diffDays} days left`;
  };

  const toggleExpand = (rfqId) => {
    setExpandedRfq(expandedRfq === rfqId ? null : rfqId);
  };

  const toggleSave = (rfqId) => {
    setSavedRfqs(prev => 
      prev.includes(rfqId) 
        ? prev.filter(id => id !== rfqId)
        : [...prev, rfqId]
    );
  };

  const handleSubmitProposal = (rfqId) => {
    if (props.onNavigateToSubmitProposal) {
      props.onNavigateToSubmitProposal(rfqId);
    }
  };

  // Filter RFQs based on search and category
  const filteredRfqs = rfqs.filter(rfq => {
    const matchesCategory = selectedCategory === 'all' || rfq.category === selectedCategory;
    const matchesSearch = searchQuery === '' || 
      rfq.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      rfq.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      rfq.company.toLowerCase().includes(searchQuery.toLowerCase()) ||
      rfq.industry.toLowerCase().includes(searchQuery.toLowerCase());
    
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="browse-rfqs-page">
      <Navigation {...props} />

      <div className="browse-content">
        <div className="page-header">
          <h1>Browse Active Projects</h1>
          <div className="header-stats">
            <span className="stat-badge">{filteredRfqs.length} Projects Found</span>
            <span className="stat-text">Click any row to view full details</span>
          </div>
        </div>

        {/* Search and Filter Bar */}
        <div className="filter-bar">
          <div className="search-box">
            <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input
              type="text"
              placeholder="Search projects, companies, or industries..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            {searchQuery && (
              <button 
                className="clear-search"
                onClick={() => setSearchQuery('')}
              >
                ×
              </button>
            )}
          </div>

          <select 
            value={selectedCategory} 
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="category-select"
          >
            <option value="all">All Categories</option>
            <option value="web-development">Web Development</option>
            <option value="graphic-design">Graphic Design</option>
            <option value="bookkeeping">Bookkeeping</option>
            <option value="software-development">Software Development</option>
            <option value="digital-marketing">Digital Marketing</option>
            <option value="writing-content">Writing & Content</option>
            <option value="photography-video">Photography & Video</option>
            <option value="it-support">IT Support</option>
            <option value="legal-services">Legal Services</option>
            <option value="data-analytics">Data Analytics</option>
          </select>
        </div>

        {/* Accordion Table */}
        <div className="rfq-table">
          {/* Table Header */}
          <div className="table-header">
            <div className="col-expand"></div>
            <div className="col-industry">Industry</div>
            <div className="col-project">Project Scope</div>
            <div className="col-posted">Posted</div>
            <div className="col-closing">Closing</div>
            <div className="col-reply">Reply</div>
            <div className="col-save">Save</div>
          </div>

          {/* Table Rows */}
          {loading ? (
            <div className="loading-state">
              <div className="loading-spinner"></div>
              <p>Loading projects...</p>
            </div>
          ) : filteredRfqs.length === 0 ? (
            <div className="empty-state">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
              <p>No projects found. Try adjusting your search or filters.</p>
            </div>
          ) : (
            filteredRfqs.map(rfq => (
              <div key={rfq.id} className={`table-row ${expandedRfq === rfq.id ? 'expanded' : ''}`}>
                {/* Collapsed Row */}
                <div className="row-main" onClick={() => toggleExpand(rfq.id)}>
                  <div className="col-expand">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </div>
                  <div className="col-industry">{rfq.industry}</div>
                  <div className="col-project">
                    <div className="project-title">{rfq.title}</div>
                    <div className="project-company">{rfq.company}</div>
                  </div>
                  <div className="col-posted">{formatDate(rfq.postedDate)}</div>
                  <div className="col-closing">
                    <div className="closing-date">{formatDate(rfq.closingDate)}</div>
                    <div className="closing-badge">{getDaysRemaining(rfq.closingDate)}</div>
                  </div>
                  <div className="col-reply">
                    <span 
                      className="reply-link"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSubmitProposal(rfq.id);
                      }}
                    >
                      Reply
                    </span>
                  </div>
                  <div className="col-save">
                    <svg 
                      viewBox="0 0 24 24" 
                      fill={savedRfqs.includes(rfq.id) ? 'currentColor' : 'none'}
                      stroke="currentColor" 
                      strokeWidth="2"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSave(rfq.id);
                      }}
                    >
                      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
                    </svg>
                  </div>
                </div>

                {/* Expanded Content */}
                {expandedRfq === rfq.id && (
                  <div className="row-expanded">
                    {/* Business Info Header */}
                    <div className="business-header">
                      <img src={rfq.companyLogo} alt={rfq.company} className="company-logo" />
                      <div className="business-details">
                        <h3>{rfq.company}</h3>
                        <div className="business-meta">
                          <span className="meta-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                            </svg>
                            {rfq.industry}
                          </span>
                          <span className="meta-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                              <circle cx="12" cy="10" r="3"/>
                            </svg>
                            {rfq.workLocation === 'remote' ? 'Remote' : rfq.specificLocation}
                          </span>
                          <span className="meta-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                              <circle cx="12" cy="7" r="4"/>
                            </svg>
                            {rfq.proposalsCount} proposals
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Main Content Grid */}
                    <div className="expanded-grid">
                      {/* Left Column - Project Details */}
                      <div className="expanded-left">
                        <div className="detail-section">
                          <h4>Project Description</h4>
                          <p>{rfq.description}</p>
                        </div>

                        <div className="detail-section">
                          <h4>Required Skills</h4>
                          <div className="skills-display">
                            {rfq.skillsRequired.map((skill, index) => (
                              <span key={index} className="skill-chip">{skill}</span>
                            ))}
                          </div>
                        </div>

                        <div className="detail-section">
                          <h4>Project Details</h4>
                          <div className="details-grid">
                            <div className="detail-box">
                              <span className="detail-label">Budget</span>
                              <span className="detail-value">{rfq.budgetDisplay}</span>
                            </div>
                            <div className="detail-box">
                              <span className="detail-label">Timeline</span>
                              <span className="detail-value">{rfq.timeline.replace(/-/g, ' ')}</span>
                            </div>
                            <div className="detail-box">
                              <span className="detail-label">Posted</span>
                              <span className="detail-value">{formatDate(rfq.postedDate)}</span>
                            </div>
                            <div className="detail-box">
                              <span className="detail-label">Deadline</span>
                              <span className="detail-value">{formatDate(rfq.closingDate)}</span>
                            </div>
                          </div>
                        </div>

                        {rfq.attachments && rfq.attachments.length > 0 && (
                          <div className="detail-section">
                            <h4>Attached Documents ({rfq.attachments.length})</h4>
                            <div className="attachments-list">
                              {rfq.attachments.map((file, index) => (
                                <div key={index} className="attachment-item">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                    <polyline points="14 2 14 8 20 8"/>
                                  </svg>
                                  <div className="attachment-info">
                                    <span className="attachment-name">{file.name}</span>
                                    <span className="attachment-size">{file.size}</span>
                                  </div>
                                  <a href={file.url} className="attachment-download" onClick={(e) => e.stopPropagation()}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                      <polyline points="7 10 12 15 17 10"/>
                                      <line x1="12" y1="15" x2="12" y2="3"/>
                                    </svg>
                                  </a>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Right Column - Requirements */}
                      <div className="expanded-right">
                        <div className="requirements-panel">
                          <h4>What You Need to Include</h4>
                          
                          <div className="requirement-section">
                            <div className="requirement-title">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                <polyline points="14 2 14 8 20 8"/>
                              </svg>
                              Work Scope
                            </div>
                            <p>{rfq.replyRequirements.workScope}</p>
                          </div>

                          <div className="requirement-section">
                            <div className="requirement-title">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                <circle cx="8.5" cy="8.5" r="1.5"/>
                                <polyline points="21 15 16 10 5 21"/>
                              </svg>
                              Portfolio
                            </div>
                            <p>{rfq.replyRequirements.portfolio}</p>
                          </div>

                          <div className="requirement-section">
                            <div className="requirement-title">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                <circle cx="12" cy="7" r="4"/>
                              </svg>
                              Experience
                            </div>
                            <p>{rfq.replyRequirements.experience}</p>
                          </div>

                          {rfq.replyRequirements.deliverables && (
                            <div className="requirement-section">
                              <div className="requirement-title">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <polyline points="20 6 9 17 4 12"/>
                                </svg>
                                Expected Deliverables
                              </div>
                              <ul className="deliverables-list">
                                {rfq.replyRequirements.deliverables.map((item, index) => (
                                  <li key={index}>{item}</li>
                                ))}
                              </ul>
                            </div>
                          )}

                          <div className="reply-action">
                            <span 
                              className="reply-link-large"
                              onClick={() => handleSubmitProposal(rfq.id)}
                            >
                              Submit Your Proposal
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>

      <Footer {...props} />
    </div>
  );
};

export default BrowseRFQ;